import {RouteContext} from "../../../RouteContext";
import {Column} from "../../common/Layout";
import {ListPage} from "../../common/ListPage";

import {
    Button,
    Dialog, DialogBody, DialogContent, DialogSurface, DialogTitle, DialogTrigger,
    makeStyles, Switch
} from "@fluentui/react-components";
import {ShoppingPathIO} from "../../../../io/content/ShoppingPathIO";
import {ShoppingPathValueObject} from "../../../../model/vo/content/ShoppingPathValueObject";
import {useError, useStatePair} from "../../../../type/States";
import TruncateText from "../../common/TruncateText";
import {visibilityName} from "../../../../constant/Visibility";
import {Types} from "../../../../type/Types";
import {shoppingPathTypeNames} from "../../../../constant/ShoppingPathType";
import {BitMask} from "../../../../utils/bitmask";
import {HttpClient} from "../../../../io/HttpClient";


const useClasses = makeStyles({
    container: {
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        alignItems: "center",
        gap: "5px",
    },
    textNone: {
        textDecorationColor:"#cecccb"
    },
    text: {
        textDecorationColor: "black",
        fontWeight: "bold"
    }
})

export default function List(props: RouteContext) {
    const classes = useClasses()

    const isActiveState = useStatePair<Map<bigint, boolean>>(new Map<bigint, boolean>())
    const uploadErrorState = useError()

    const setActive = (id: bigint, isActive: boolean) => {
        const acc = new Map<bigint, boolean>(isActiveState.value)
        acc.set(id, isActive)
        isActiveState.setValue(acc)
    }

    const json = require('json-bigint')({
        alwaysParseAsBig: true,
        useNativeBigInt: true
    })

    const updateIds = async (ids: bigint[], wishState: boolean) => {
        const body = { wishState: wishState }
        const res: bigint[] = []

        try {
            await Promise.all([...ids].map(async (id) => {
                try {
                    const response = await fetch(
                        `${process.env.REACT_APP_API_HOST}/api/v3/contents/shoppings/paths/${id}/state`,
                        {
                            method: 'PATCH',
                            headers: {
                                'Content-Type': 'application/json',
                            },
                            credentials: 'include',
                            body: Types.asUndefined(body, json.stringify)
                        }
                    )

                    if (response.ok) {
                        res.push(id)
                    } else {
                        throw new Error(await response.text())
                    }
                } catch (error) {
                    // @ts-ignore
                    uploadErrorState.setDefinedValue(error)
                }
            }))

            const message =
                res.length === ids.length ? '전체 수정 성공' :
                    res.length > 0 ? '일부 수정 성공' :
                        '수정 실패'

            console.log(res.map(v => v.toString()))
            alert(message)
            window.location.reload()
        } catch (error) {
            console.error('Update failed:', error)
            alert('수정 실패')
        }
    }

    return <>
        <Column gap={'16px'}>
            <ListPage
                {...props}
                description={ShoppingPathValueObject.description}
                list={ShoppingPathIO.list}
                count={ShoppingPathIO.count}
                deleteIds={ShoppingPathIO.deleteIds}
                postHref={'/admin/shoppings/paths/post'}
                detailHref={item => `/admin/shoppings/paths/${item.id}`}
                editHref={item => `/admin/shoppings/paths/edit/${item.id}`}
                updateIds={updateIds}
                initialSearchConditions={[
                    {
                        name: 'deletedAt',
                        value: '',
                        condition: 'IsNull'
                    },
                ]}
                itemValue={(item, key) => {
                    if (key === 'isActive') {
                        const present = isActiveState.value.get(item.id)
                        if (present !== undefined) {
                            return <>
                                <Switch
                                    checked={present}
                                    onChange={(ev, data) => {

                                        const id = Number(item.id.toString().split('n')[0])

                                        fetch(`${process.env.REACT_APP_API_HOST}/api/v3/contents/shoppings/paths/${id}/state`,
                                            {
                                                method: 'PATCH',
                                                headers: {
                                                    'Content-Type': 'application/json',
                                                },
                                                credentials: 'include',
                                                body: JSON.stringify({
                                                    wishState: data.checked,
                                                }),
                                            }
                                        )
                                            .then(async value => {
                                                const res = await value.json()
                                                console.log(res)

                                                if (!res) {
                                                    return
                                                }

                                                setActive(item.id, data.checked)

                                            })
                                    }
                                    }

                                />
                            </>
                        } else {
                            return <>
                                <Switch
                                    checked={item.isActive}
                                    onChange={(ev, data) => {

                                        const id = Number(item.id.toString().split('n')[0])
                                        fetch(`${process.env.REACT_APP_API_HOST}/api/v3/contents/shoppings/paths/${id}/state`,
                                            {
                                                method: 'PATCH',
                                                headers: {
                                                    'Content-Type': 'application/json',
                                                },
                                                credentials: 'include',
                                                body: JSON.stringify({
                                                    wishState: data.checked,
                                                }),
                                            }
                                        )
                                            .then(async value => {
                                                const res = await value.json()
                                                console.log(res)

                                                if (!res) {
                                                    return
                                                }

                                                setActive(item.id, data.checked)

                                            })
                                    }
                                    }/>
                            </>
                        }
                    }
                    else if(key == 'format'){
                        return <TruncateText text={item[key] || ''} maxLength={20}/>
                    }
                    else if(key === 'visibility'){
                        return<>
                            <Dialog modalType="non-modal">
                                <DialogTrigger disableButtonEnhancement>
                                    <Button>{item.visibility}</Button>
                                </DialogTrigger>
                                <DialogSurface>
                                    <DialogBody>
                                        <DialogTitle>보임여부</DialogTitle>
                                        <DialogContent>
                                            {
                                                visibilityName.map((name, idx) => {
                                                    const isVisible = !!(Number(item.visibility) & (1 << idx));
                                                    return (
                                                        <div key={idx} className={isVisible ? classes.text : classes.textNone}>
                                                            {name}
                                                        </div>
                                                    );
                                                })
                                            }
                                        </DialogContent>
                                    </DialogBody>
                                </DialogSurface>
                            </Dialog>
                        </>
                    }
                    else if(key === 'type') {
                        return<>
                            <Dialog modalType="non-modal">
                                <DialogTrigger disableButtonEnhancement>
                                    <Button>{item.type}</Button>
                                </DialogTrigger>
                                <DialogSurface>
                                    <DialogBody>
                                        <DialogTitle>유형</DialogTitle>
                                        <DialogContent>
                                            {
                                                shoppingPathTypeNames.map((name, idx) => {
                                                    const isEnabled = BitMask.isEnabled(item.type, idx)
                                                    return (
                                                        <div key={idx} className={isEnabled ? classes.text : classes.textNone}>
                                                            {name}
                                                        </div>
                                                    );
                                                })
                                            }
                                        </DialogContent>
                                    </DialogBody>
                                </DialogSurface>
                            </Dialog>
                        </>
                    }
                    else {
                        return undefined
                    }
                }
            }
                uploadSheetUrls={[
                    { name: '엑셀 경로 생성 업로드', url: `${process.env.REACT_APP_API_HOST}/api/v3/contents/shoppings/paths/excel`, method: 'POST' },
                    { name: '엑셀 경로 수정 업로드', url: `${process.env.REACT_APP_API_HOST}/api/v3/contents/shoppings/paths/excel`, method: 'PUT' },
                ]}
                downloadSheetUrl={(searchConditions, sortOrders, offset,count) =>
                    HttpClient.buildUrl(
                        `${process.env.REACT_APP_API_HOST}/api/v3/contents/shoppings/paths/excel`,
                        searchConditions,
                        sortOrders,
                        count,
                        offset,
                    )}
                downloadSheetExampleUrls={[
                    { name: '경로 생성 액셀 양식', url: `${process.env.REACT_APP_API_HOST}/api/v3/contents/shoppings/paths/excel/example/post`, },
                ]}
            />
        </Column>
    </>
}